import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, Renderer2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SupportScriptsService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  private addGoogleTagManager(renderer2: Renderer2, document: Document): void {
    let script = renderer2.createElement('script');
    script.text = `
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          "gtm.start": new Date().getTime(),
          event: "gtm.js",
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", "GTM-5N4BH5B5");
    `;
    script.type = 'text/javascript';
    renderer2.appendChild(document.head, script);
  }

  private addSecuritiAI(renderer2: Renderer2, document: Document): void {
    let script = renderer2.createElement('script');
    script.text = `
      (function () {
        var s = document.createElement("script");
        s.src =
          "https://cdn-prod.securiti.ai/consent/cookie-consent-sdk-loader.js";
        s.setAttribute(
          "data-tenant-uuid",
          "da0bdc52-8ccb-405a-a420-0a5a9ef4467e"
        );
        s.setAttribute(
          "data-domain-uuid",
          "72ee5f32-627d-4c37-944e-4eca25027aaf"
        );
        s.setAttribute("data-backend-url", "https://app.securiti.ai");
        s.setAttribute("data-skip-css", "false");
        s.defer = true;
        var parent_node = document.head || document.body;
        parent_node.appendChild(s);
      })();
    `;
    script.type = 'text/javascript';
    renderer2.appendChild(document.body, script);
  }

  public injectScripts(renderer2: Renderer2, document: Document): void {
    this.addGoogleTagManager(renderer2, document);

    if (isPlatformBrowser(this.platformId)) {
      // this.addSecuritiAI(renderer2, document);
    }
  }
}
